const isDevelopment = process.env.REACT_APP_ENV === 'development';

const logger = {
  log: (...messages) => {
    if (isDevelopment) {
      const { file, line } = getCallerFileInfo();
      console.log(`[${dateTime()}] [${file}:${line}]`, ...messages);
    }
    // Additional actions for logging, e.g., sending to a logging service
  },
  error: (...messages) => {
    if (isDevelopment) {
      const { file, line } = getCallerFileInfo();
      console.error(`[${dateTime()}] [${file}:${line}]`, ...messages);
    }
    // Additional actions for errors
  },
  warn: (...messages) => {
    if (isDevelopment) {
      const { file, line } = getCallerFileInfo();
      console.warn(`[${dateTime()}] [${file}:${line}]`, ...messages);
    }
    // Additional actions for warnings
  },
};

function getCallerFileInfo() {
  return { file: 'unknown', line: '?' };
  const err = new Error();
  const stackLines = err.stack.split('\n');
  // Look for the first line outside this script file
  for (let i = 2; i < stackLines.length; i++) {
    if (stackLines[i].indexOf('logger.js') === -1) {
      const match = stackLines[i].match(/(http[s]?:\/\/.*?):(\d+):(\d+)/);
      if (match) {
        return {
          file: match[1],
          line: match[2],
        };
      }
      break;
    }
  }
  return { file: 'unknown', line: '?' };
}

function dateTime() {
  return new Date().toISOString();
}

export default logger;
